import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Button, Card, Row, Col, Form, Table, Modal } from 'react-bootstrap';
import { serviceAddProcesoJudicial, serviceGetCfgForm, serviceGetCombos, serviceGetImplicadosTerceros, serviceGetTribunales } from '../../../../../api/api-antecendentes-legales';
import { useFormik } from 'formik';
import { dateFormat, today, isValidParam } from '../../../../../common/Formatos';
import { LoadingComponent } from 'recupero-comunes';
import { validationSchemasProcesoJudicial } from '../../../../../common/validation-Shemas-antecedentes-legales';
import Mensajes from '../../../../mensajes'

const AddModProceso = ({ showAddMod, setShowAddMod, setCancelSubmit, proceso, fechaSinistro }) => {
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer);
    const { llaves } = data_recepciona;
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [competencias, setCompetencias] = useState([]);
    const [cortes, setCortes] = useState([]);
    const [tribunales, setTribunales] = useState([]);
    const [libros, setLibros] = useState([]);
    const [librosAux, setLibrosAux] = useState([]);
    const [implicadosTerceros, setImplicadosTerceros] = useState([]);
    const [implicadosTercerosBool, setImplicadosTercerosBool] = useState([]);
    const [implicadosSelect, setImplicadosSelect] = useState([]);

    const [stateCorte, setStateCorte] = useState("");
    const [stateCompetencia, setStateCompetencia] = useState("");
    const [stateTribunal, setStateTribunal] = useState("");
    const [stateLibro, setStateLibro] = useState("");
    const [stateRol, setStateRol] = useState("");
    const [stateFechaIngreso, setStateFechaIngreso] = useState("");

    const [showToast, setShowToast] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [responseData, setResponseData] = useState({});
    const [disableVolver, setDisableVolver] = useState(false);
    const [disableActualizar, setDisableActualizar] = useState(false);

    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [handleDataSubmit, setHandleDataSubmit] = useState(null);

    useEffect(() => {
        if (showAddMod) { initialData(); if (proceso) loadModData(); }
        else { clearFields(); }
    }, [showAddMod])

    useEffect(() => {
        if (showAddMod) {
            const aux = [];
            const auxBools = [];
            implicadosTerceros.forEach(_ => auxBools.push(false));
            proceso?.implicados.forEach(element => { aux.push(element.idImplicado); });

            implicadosTerceros.forEach((element, index) => {
                if (aux.includes(element.IdImplicado)) auxBools[index] = true;
            })
            if (implicadosTerceros && implicadosTerceros.length == 1) {
                auxBools[0] = true;
                setImplicadosSelect([{idImplicado: implicadosTerceros[0].IdImplicado}]);
            }
            setImplicadosTercerosBool(auxBools);
        }
    }, [implicadosTerceros])

    useEffect(() => {
        if (showAddMod && stateCompetencia !== "" && competencias.length > 0 && libros.length > 0) {
            getCortes();

            const shortLibros = libros.filter(c => c.agrupacion === Number(stateCompetencia));
            setLibrosAux(shortLibros);
        }
    }, [stateCompetencia, competencias, libros])

    useEffect(() => {
        if (showAddMod) {
            if (stateCompetencia !== "" && stateCorte !== "") getTribunales();
            else setTribunales([]);
        }
    }, [stateCompetencia, stateCorte])

    const initialData = async () => {
        setLoading(true);

        await getCfgForm();
        await getCompetencias();
        await getLibros();
        await getImplicadosTerceros();
    }

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 46 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getCompetencias = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 240 })).toString('base64');
        const response = await serviceGetCombos(query);

        setCompetencias(response);
    }

    const getCortes = async () => {
        const concepto = competencias.filter(c => c.id === Number(stateCompetencia))[0]?.accion;
        const query = Buffer.from(JSON.stringify({ concepto: concepto })).toString('base64');
        const response = await serviceGetCombos(query);

        setCortes(response);
    }

    const getTribunales = async () => {
        const query = Buffer.from(JSON.stringify({ idCompetencia: stateCompetencia, idCorte: stateCorte })).toString('base64');
        const response = await serviceGetTribunales(query);

        setTribunales(response);
    }

    const getLibros = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 242 })).toString('base64');
        const response = await serviceGetCombos(query);

        setLibros(response);
    }

    const getImplicadosTerceros = async () => {
        const query = Buffer.from(JSON.stringify({ idOrgCaso: llaves.idOrgCaso, idCaso: llaves.idCaso })).toString('base64');
        const response = await serviceGetImplicadosTerceros(query);

        setLoading(false);
        setImplicadosTerceros(response);
    }

    const handleChange = (checked, implicado, pos) => {
        const auxData = implicadosSelect;
        const auxCheckeds = [];

        implicadosTercerosBool.forEach(value => auxCheckeds.push(value));
        auxCheckeds[pos] = checked;

        if (checked) auxData.push({ idImplicado: implicado.IdImplicado });
        else {
            const index = auxData.findIndex(value => value.idImplicado === implicado.IdImplicado);
            if (index !== -1) auxData.splice(index, 1);
        }

        setImplicadosSelect(auxData);
        setImplicadosTercerosBool(auxCheckeds);
    }

    const handleChangeCompetencia = (value) => {
        setStateCompetencia(value);
        if (value === "") { setCortes([]); setTribunales([]) }
    }

    const loadModData = () => {
        const auxCheckeds = [];

        setStateCorte(proceso.idCorte);
        setStateCompetencia(proceso.idCompetencia);
        setStateTribunal(proceso.idTribunalJuz);
        setStateLibro(proceso.idLibro);
        setStateRol(proceso.rolCausa);
        setStateFechaIngreso(isValidParam(proceso.fecIngresaCausaFormat) ? dateFormat(proceso.fecIngresaCausaFormat) : '');

        proceso?.implicados.forEach(element => { auxCheckeds.push({ idImplicado: element.idImplicado }); });
        setImplicadosSelect(auxCheckeds);
        
        if (proceso.estado != 265001) {
            setDisableActualizar(true);
        }
    }

    const handleCloseToast = () => {
        setShowToast(false);
        setDisableVolver(false);
        if (responseData?.code === 1) { clearFields(); setShowAddMod(false); setCancelSubmit("submit") }
    }

    const clearFields = () => {
        formik.resetForm();

        setStateCorte("");
        setStateCompetencia("");
        setStateTribunal("");
        setStateLibro("");
        setStateRol("");
        setStateFechaIngreso("");
        setCortes([]);
        setLibros([]);
        setTribunales([]);
        setImplicadosTerceros([]);
        setImplicadosSelect([]);
        setDisableActualizar(false);
    }
    const crearProcesoJudicial = async (dataSubmit) => {
        const data = showModalConfirm ? handleDataSubmit : dataSubmit;
        setLoading(true);
        setShowModalConfirm(false);
        const response = await serviceAddProcesoJudicial(data);

        setLoading(false);
        setResponseData(response);
        setShowToast(true);
    }
    const formik = useFormik({
        initialValues: {
            corte: "",
            competencia: "",
            tribunal: "",
            libro: "",
            rol: "",
            fechaIngresoCausa: "",
            glosaCompetencia: ""
        },
        validationSchema: validationSchemasProcesoJudicial(),
        onSubmit: async (data) => {
            if (implicadosSelect.length > 0) {
                setDisableVolver(true);
                const dataResult = { ...data };

                dataResult.idCaso = llaves.idCaso;
                dataResult.idOrganizacion = llaves.idOrgCaso;
                dataResult.idUsuario = llaves.idUsuario;
                dataResult.instanciaProceso = !proceso ? "0" : proceso.idInstancia;
                dataResult.accion = !proceso ? 1 : 2;
                dataResult.implicados = implicadosSelect;
                dataResult.estadoProceso = 265001;
                dataResult.fechaIngresoCausa = data.fechaIngresoCausa.split('-').join('');

                dataResult.glosaCompetencia = competencias.filter(c => Number(c.id) === Number(dataResult.competencia))[0]?.nombre;

                if (!isValidParam(dataResult.fechaIngresoCausa)) {
                    setHandleDataSubmit(dataResult);
                    setShowModalConfirm(true);
                } else {                    
                    crearProcesoJudicial(dataResult);
                }
            } else {
                setShowModal(true);
            }
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showAddMod} onHide={setShowAddMod} size='xl'>
                <Form onSubmit={formik.handleSubmit}>
                    <Card>
                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            {cfg_form && (!proceso ? cfg_form["modalprocesojudicialdefensa-titleing"] : cfg_form["modalprocesojudicialdefensa-titleact"])}
                        </Card.Header>

                        <Card.Body>
                            <Row>
                                <Col md='3'>
                                    <Form.Label className="is_required">
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-cmb-competencia"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Select
                                        name='competencia'
                                        value={formik.values.competencia = stateCompetencia}
                                        onChange={(e) => { formik.handleChange(e); handleChangeCompetencia(e.target.value) }}>

                                        <option value={''}>Seleccione...</option>
                                        {competencias.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {formik.errors.competencia && formik.touched.competencia &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.competencia}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3'>
                                    <Form.Label className="is_required">
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-cmb-regioncorte"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Select
                                        name='corte'
                                        value={formik.values.corte = stateCorte}
                                        onChange={(e) => { formik.handleChange(e); setStateCorte(e.target.value) }}>

                                        <option value={''}>Seleccione...</option>
                                        {cortes.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {formik.errors.corte && formik.touched.corte &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.corte}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='6'>
                                    <Form.Label className="is_required">
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-cmb-juztribu"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Select
                                        name='tribunal'
                                        value={formik.values.tribunal = stateTribunal}
                                        onChange={(e) => { formik.handleChange(e); setStateTribunal(e.target.value) }}>

                                        <option value={''}>Seleccione...</option>
                                        {tribunales.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {formik.errors.tribunal && formik.touched.tribunal &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.tribunal}
                                        </Form.Text>
                                    }
                                </Col>

                                <Col md='3' className='mt-2'>
                                    <Form.Label>
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-cmb-librotipo"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Select
                                        name='libro'
                                        value={formik.values.libro = stateLibro}
                                        onChange={(e) => { formik.handleChange(e); setStateLibro(e.target.value) }}>

                                        <option value={''}>Seleccione...</option>
                                        {librosAux.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md='3' className='mt-2'>
                                    <Form.Label className="is_required">
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-input-causarol"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Control
                                        name='rol'
                                        maxLength={10}
                                        value={formik.values.rol = stateRol}
                                        onChange={(e) => { formik.handleChange(e); setStateRol(e.target.value) }}>
                                    </Form.Control>
                                    {formik.errors.rol && formik.touched.rol &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.rol}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mt-2'>
                                    <Form.Label>
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-input-fechaing"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Control
                                        type="date"
                                        name='fechaIngresoCausa'
                                        min={dateFormat(fechaSinistro)}
                                        max={today()}
                                        value={formik.values.fechaIngresoCausa = stateFechaIngreso}
                                        onChange={e => { formik.handleChange(e); setStateFechaIngreso(e.target.value) }}
                                        error={formik.errors.fechaIngresoCausa}>
                                    </Form.Control>
                                    {formik.errors.fechaIngresoCausa && formik.touched.fechaIngresoCausa &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.fechaIngresoCausa}
                                        </Form.Text>
                                    }
                                </Col>
                                <Col md='3' className='mt-2'>
                                    <Form.Label>
                                        {cfg_form && cfg_form["modalprocesojudicialdefensa-cmb-estado"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Control
                                        disabled
                                        name='estado'
                                        value={!proceso ? "" : proceso.glosaEstado}>
                                    </Form.Control>
                                </Col>
                            </Row>

                            <hr className='mt-4' style={{ borderTop: '3px solid #04005D' }}></hr>

                            <Card>
                                <Card.Header className="customHeaderCard">
                                    {cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-title"]}
                                </Card.Header>

                                <Card.Body className="customCard">
                                    <Table striped className="customTable">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-id"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-nombr"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-tipoi"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-paten"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-tipog"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-estad"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-feces"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-segur"]}</th>
                                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-grillaimplicados-cia"]}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {implicadosTerceros.map((implicado, index) => (
                                                <tr key={index}>
                                                    <td >
                                                        <Form.Check
                                                            onChange={(e) => handleChange(e.target.checked, implicado, index)}
                                                            checked={implicadosTercerosBool[index] ? implicadosTercerosBool[index] : false}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.IdImplicado}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.NombreImplicado}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.GlosaBienImplicado}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.PlacaPatente}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.TipoGestion}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.EstadoCaso}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.FechaEstadoFormat}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.SeguroImplicado}</td>
                                                    <td style={{ textAlign: 'center' }}>{implicado.CiaImplicado}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Card.Body>
                        {showToast && 
                            <Mensajes
                                showToast={showToast}
                                handleCloseToast={handleCloseToast}
                                delay={5000}
                                responseData={responseData}
                            ></Mensajes>
                        }
                        <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                            <Button disabled={disableVolver} className='w-auto' variant='outline-info' onClick={() => { setCancelSubmit("cancel"); setShowAddMod(false); }}>{cfg_form && cfg_form["modalprocesojudicialdefensa-btn-volver"]}</Button>
                            <Button disabled={disableActualizar} type="submit" className='w-auto' variant='danger'>{cfg_form && (!proceso ? cfg_form["modalprocesojudicialdefensa-btn-crearproceso"] : cfg_form["modalprocesojudicialdefensa-btn-actproceso"])}</Button>
                        </Card.Footer>
                    </Card>
                </Form>
            </Modal>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Información
                    </Card.Header>
                    <Card.Body>
                        Debe seleccionar al menos un implicado antes de continuar.
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>
                    <Card.Body>
                        Fecha Ingreso Causa no informada. ¿Desea continuar?
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalConfirm(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={() => crearProcesoJudicial()}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customHeaderCard {
                        background-color: rgb(176 175 196);
                        color: #3a3a8d;
                        font-size: 17px;
                        font-weight: 600
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                    .is_required:after {
                        content: "(*)";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default AddModProceso;